import { render, staticRenderFns } from "./PreOrderMaterials.vue?vue&type=template&id=5344e12c&scoped=true&"
import script from "./PreOrderMaterials.vue?vue&type=script&lang=js&"
export * from "./PreOrderMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344e12c",
  null
  
)

export default component.exports